import { MatchGroupResult } from 'dashboard/models/verification';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum ReportRunMatchStatus {
  Matched = 'matched',
  NoMatch = 'no_match',
  Dismissed = 'dismissed',
  Restricted = 'restricted',
}

export interface ReportRunCustomListAttributes {
  'primary-input': string;
  result: ReportRunMatchStatus;
  'scheduled-at': string;
  'completed-at': string;
  'hit-entries': ReportRunCustomListHitEntry[] | undefined;
  'dismissed-entries': ReportRunCustomListHitEntry[] | undefined;
}

export interface ReportRunDismissal {
  'dismissed-at': string;
  'row-number': number;
  reason: string;
  'creator-name': string;
}

export interface ReportRunCustomListHitEntry {
  // These two attributes are used for FINCEN
  'comparison-detail': Record<string, ReportRunCustomListComparison | null> & {
    'row-number': number;
  };
  'match-rules': string[];

  // These two attributes are used for Custom Screening Reports
  'match-group-results': MatchGroupResult[];
  'row-number': number;

  dismissal?: ReportRunDismissal;
}

interface ReportRunCustomListComparison {
  'custom-list-record-value': string;
  'display-property': string;
  'query-value': string;
  signals: string[];
  status: CustomListComparisonMatchType;
}

export enum CustomListComparisonMatchType {
  Full = 'full',
  Partial = 'partial',
  NoMatch = 'no_match',
}

export interface ReportRunRelationships {
  report: ApiRelationship<ApiModel.ReportCustomList>;
  'report-template': ApiRelationship<ApiModel.ReportTemplateCustomList>;
  'report-template-version': ApiRelationship<ApiModel.ReportTemplateVersionCustomList>;
}

export type ReportRunCustomList = ApiResource<
  ReportRunCustomListAttributes,
  ReportRunRelationships,
  ApiModel.ReportRunCustomList
>;

export type ReportRun =
  | ApiResource<ReportRunCustomListAttributes, ReportRunRelationships, ApiModel.ReportRun>
  | ReportRunCustomList;

export const SUPPORTED_REPORT_RUN_TYPES = [ApiModel.ReportRunCustomList];

export type ReportRunCustomListDismissPayload = ApiResource<
  {
    'row-number': number;
    reason: string;
  },
  void,
  ApiModel.ReportRunCustomList
>;
